import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import $ from 'jquery'
// CSS
import '../assets/css/navbar.css'
// Images
import Branding from '../logo.png'
// Icons
import SearchIcon from '../assets/icons/search.png'
import PhoneIcon from '../assets/icons/phone.png'
import UserIcon from '../assets/icons/user.png'
import HeartIcon from '../assets/icons/heart.png'
import CartIcon from '../assets/icons/cart.png'

export default function Navbar(props) {
  const [showSidenav, setShowSidenav] = useState(false);

  $(window).scroll(function(){
    if(this.scrollY > 1){
      $(".main_nav").addClass("sticky");
    }
    else{
      $(".main_nav").removeClass("sticky");
    }
  });

  function showSubLinks(key){
    $(".sub_links_" + key).toggleClass("show");
  }

  useEffect(() => {
    if(showSidenav){
      document.body.style.overflow = 'hidden';
    }
    else{
      document.body.style.overflow = 'auto';
    }
  }, [showSidenav])

  function handleSidenavLinkPress(){
    setTimeout(() => {
      setShowSidenav(false);
    }, 300)
  }

  return (
    <>
      <nav className='main_nav'>
        <div className='main_nav_top'>
          <div className='container'>
            <div className='settings'>
              <div className='input_container'>
                <label htmlFor='lang'></label>
                <select id='lang'>
                  <option value='en'>En</option>
                  <option value='en'>Bn</option>
                </select>
              </div>
              
              <div className='input_container'>
                <select id='currency'>
                  <option value='en'>USD</option>
                  <option value='en'>BDT</option>
                </select>
              </div>
            </div>
  
            <div className='links select_n'>
              <ul className='nav_links'>
                <li><a href='#welcome'>WELCOME TO HOVSHOP!</a></li>
                <li><NavLink to='/products'>PRODUCTS</NavLink></li>
                <li><NavLink to='/blogs'>BLOGS</NavLink></li>
                <li><NavLink to='/about'>ABOUT</NavLink></li>
                <li><NavLink to='/contact'>CONTACT</NavLink></li>
                <li><NavLink to='/login'>LOG IN</NavLink></li>
              </ul>
              <ul className='social_links'>
                <a href='https://fb.com/forhadhossain60'><span className='fab fa-facebook'></span></a>
                <a href='https://twitter.com/forhadhossain60'><span className='fab fa-twitter'></span></a>
                <a href='https://instagram.com/forhadhossain60'><span className='fab fa-instagram'></span></a>
              </ul>
            </div>
          </div>
        </div>
  
        <div className='main_nav_bottom'>
          <div className='container'>
            <div className='main_nav_branding select_n'>
              <span className='fa-solid fa-bars-staggered' onClick={() => {setShowSidenav(true)}}></span>
              <Link to='/' onClick={() => {window.scrollTo(0, 0)}}><img src={Branding} alt='logo' /></Link>
            </div>
  
            <form className='main_nav_search'>
              <input type='text' placeholder='Search' />
              <button type='submit'><img src={SearchIcon} alt='Search Icon' /></button>
            </form>
  
            <div className='cell_contact'>
              <img className='select_n' src={PhoneIcon} alt='Phone Icon' />
              <div className='info'>
                <span className='select_n'>CALL US NOW</span>
                <p>+880-1711-988-988</p>
              </div>
            </div>
  
            <ul className='links select_n'>
              <li><NavLink to='/my-account'><img src={UserIcon} alt='User Icon' /></NavLink></li>
              <li><NavLink to='/wishlist'><img src={HeartIcon} alt='Heart Icon' /></NavLink></li>
              <li className='cart'>
                <NavLink to='/cart'>
                  <img src={CartIcon} alt='Cart Icon' />
                  <span className='count'>2</span>
                </NavLink>
                
                <div className='dropdown'>
                  <div className='header'>
                    <span className='cart_count'>02 Items</span>
                    <Link to='/cart'>View Cart</Link>
                  </div>
                  <div className='content'>
                    <Link to='/product/a' className='item'>
                      <Link className='thumbnail' to='/product'>
                        <img src='https://via.placeholder.com/150' alt='product' />
                      </Link>
                      <div className='infos'>
                        <Link className='title' to='/product'>Full Black T shirt Cotton quality.</Link>
                        <div className='price'>2<span className='fas fa-times'></span>$100.00</div>
                      </div>
                    </Link>
                    <Link to='/product/a' className='item'>
                      <Link className='thumbnail' to='/product'>
                        <img src='https://via.placeholder.com/150' alt='product' />
                      </Link>
                      <div className='infos'>
                        <Link className='title' to='/product'>Full Black T shirt Cotton quality.</Link>
                        <div className='price'>2<span className='fas fa-times'></span>$100.00</div>
                      </div>
                    </Link>
                    <Link to='/product/a' className='item'>
                      <Link className='thumbnail' to='/product'>
                        <img src='https://via.placeholder.com/150' alt='product' />
                      </Link>
                      <div className='infos'>
                        <Link className='title' to='/product'>Full Black T shirt Cotton quality.</Link>
                        <div className='price'>2<span className='fas fa-times'></span>$100.00</div>
                      </div>
                    </Link>
                    
                    <div className='actions'>
                      <Link className='primary_btn' to='/checkout'>Checkout</Link>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
  
      <nav className={showSidenav? 'side_nav show' : 'side_nav'}>
        <div className='close_btn'><span className='fas fa-times' onClick={() => {setShowSidenav(false)}}></span></div>
        <ul className='links'>
          <li><NavLink to='/' onClick={handleSidenavLinkPress}><div className='left'><span className='fas fa-home'></span> Home</div></NavLink></li>
          <li><a onClick={() => {showSubLinks(1);}}><div className='left'><span className='fas fa-th'></span> Categories</div> <span className='fas fa-chevron-down'></span></a>
            <ul className={'sub_links sub_links_1'}>
            {
              props.categories.map((category, index) => {
                return (
                  <li key={index}><a onClick={() => {showSubLinks(index+'2')}}><div className='left'>{category.name}</div> <span className='fas fa-chevron-down'></span></a>
                    <ul className={'sub_links sub_links_'+index+2}>
                      {
                        category.subCategories.map((subCategory, index) => {
                          return (
                            <li key={index}><NavLink to={subCategory.link} onClick={handleSidenavLinkPress}><div className='left'>{subCategory.name}</div></NavLink></li>
                          )
                        })
                      }
                    </ul>
                  </li>
                )
              })
            }
            </ul>
            {/* <ul className='sub_links sub_links_1'>
              <li><a onClick={() => {showSubLinks(2)}}><div className='left'>Category 1</div> <span className='fas fa-chevron-down'></span></a>
                <ul className='sub_links sub_links_2'>
                  <li><NavLink to='/category/1' onClick={handleSidenavLinkPress}><div className='left'>Sub Category 1</div></NavLink></li>
                  <li><NavLink to='/category/2' onClick={handleSidenavLinkPress}><div className='left'>Sub Category 1</div></NavLink></li>
                  <li><NavLink to='/category/3' onClick={handleSidenavLinkPress}><div className='left'>Sub Category 1</div></NavLink></li>
                  <li><NavLink to='/category/4' onClick={handleSidenavLinkPress}><div className='left'>Sub Category 1</div></NavLink></li>
                </ul>
              </li>
              <li><a onClick={() => {showSubLinks(3)}}><div className='left'>Category 2</div> <span className='fas fa-chevron-down'></span></a>
                <ul className='sub_links sub_links_3'>
                  <li><NavLink to='/category/5' onClick={handleSidenavLinkPress}><div className='left'>Sub Category 1</div></NavLink></li>
                  <li><NavLink to='/category/6' onClick={handleSidenavLinkPress}><div className='left'>Sub Category 1</div></NavLink></li>
                  <li><NavLink to='/category/7' onClick={handleSidenavLinkPress}><div className='left'>Sub Category 1</div></NavLink></li>
                  <li><NavLink to='/category/8' onClick={handleSidenavLinkPress}><div className='left'>Sub Category 1</div></NavLink></li>
                </ul>
              </li>
            </ul> */}
          </li>
          <li><NavLink to='/products' onClick={handleSidenavLinkPress}><div className='left'><span className='fas fa-shopping-cart'></span> Products</div></NavLink></li>
          <li><NavLink to='/blogs' onClick={handleSidenavLinkPress}><div className='left'><span className='fas fa-blog'></span> Blogs</div></NavLink></li>
          <li><NavLink to='/about' onClick={handleSidenavLinkPress}><div className='left'><span className='fas fa-users'></span> About Us</div></NavLink></li>
          <li><NavLink to='/contact' onClick={handleSidenavLinkPress}><div className='left'><span className='fas fa-users'></span> Contact</div></NavLink></li>
        </ul>
        <ul className='links'>
          <li><Link to='/account' onClick={handleSidenavLinkPress}>MY ACCOUNT</Link></li>
          <li><Link to='/contact' onClick={handleSidenavLinkPress}>CONTACT US</Link></li>
          <li><Link to='/wishlist' onClick={handleSidenavLinkPress}>MY WISHLIST</Link></li>
          <li><Link to='/cart' onClick={handleSidenavLinkPress}>CART</Link></li>
          <li><Link to='/login' onClick={handleSidenavLinkPress}>LOG IN</Link></li>
        </ul>
        <form className='search_form'>
          <input type='text' placeholder='Search' />
          <button className='fas fa-search' onClick={handleSidenavLinkPress}></button>
        </form>
      </nav>

      <nav className='bottom_nav'>
        <ul className='links'>
          <li><NavLink to='/'><span className='fas fa-home'></span> <p>Home</p></NavLink></li>
          <li><NavLink to='/products'><span className='fas fa-th'></span> <p>Categories</p></NavLink></li>
          <li><NavLink to='/blogs'><span className='fas fa-blog'></span> <p>Blogs</p></NavLink></li>
          <li className='cart'><NavLink to='/cart'><span className='fas fa-shopping-cart'></span> <p>Cart</p></NavLink></li>
          <li><NavLink to='/my-account'><span className='far fa-user'></span> <p>Account</p></NavLink></li>
        </ul>
      </nav>
    </>
  )
}